import { createSlice } from "@reduxjs/toolkit";
import { localStoragePrefix } from "../../../utils/GeneralFunc";

const initialUsercartItems = JSON.parse(
  localStorage.getItem(`${localStoragePrefix}cartItems`)
);
const initialUsercart = JSON.parse(
  localStorage.getItem(`${localStoragePrefix}cart`)
);

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
    cart: [],
    checkedItems: [],
    changed: false,
  },
  reducers: {
    cartDataChanged(state) {
      state.changed = true;
    },
    replaceCart(state, action) {
      state.items = action.payload.items;
      state.cart = action.payload.cart;
      state.changed = false;
      localStorage.setItem(
        `${localStoragePrefix}cartItems`,
        JSON.stringify(state.items)
      );
      localStorage.setItem(
        `${localStoragePrefix}cart`,
        JSON.stringify(state.cart)
      );
    },
    checkedCartItems(state, action) {
      const cartItems = action.payload;
      // replace array with a new array
      state.checkedItems.splice(0, state.checkedItems.length, ...cartItems);
    },
  },
});

export const cartAction = cartSlice.actions;

export default cartSlice;
